import React from "react";

export function FullSponsorRow({ entry, onJump }) {
  return (
    <div className={"sp-row" + (entry.coSponsored ? " is-shared" : "")}>
      <div className="sp-offering">{entry.offering}</div>
      <div className="sp-sponsor">
        {entry.coSponsored && (
          <>
            <span className="sp-badge">Co-sponsored</span>
            {entry.coAnchorId !== "" && onJump != null && (
              <button
                className="sp-jump"
                type="button"
                onClick={() => onJump(entry.coAnchorId)}
              >
                See the sponsors
              </button>
            )}
          </>
        )}
        {!entry.coSponsored && entry.sponsorName !== "" && (
          <>
            Sponsored by <b>{entry.sponsorName}</b>
          </>
        )}
        {!entry.coSponsored && entry.sponsorName === "" && (
          <span className="sp-badge">Sponsor not listed</span>
        )}
      </div>
    </div>
  );
}

export function CoSponsorCard({ entry, highlighted }) {
  return (
    <div
      className={
        "sp-card" +
        (entry.open ? " is-open" : "") +
        (highlighted ? " is-target" : "")
      }
      id={entry.anchorId}
    >
      <div className="sp-card-top">
        <h3>{entry.offering}</h3>
      </div>
      <div className="sp-card-meta">
        {entry.open && "Community offering"}
        {!entry.open && entry.namesWithheld === true && "Community offering"}
        {!entry.open && entry.namesWithheld !== true && (
          <span className="sp-tally">
            {entry.sponsorCount} {entry.sponsorCount === 1 ? "sponsor" : "sponsors"}
          </span>
        )}
      </div>
      {entry.open && (
        <div className="sp-open-state">
          <span className="sp-open-dot" />
          <span>
            <b>Open for sponsorship</b> &mdash; be the first to offer.
          </span>
        </div>
      )}
      {/* Taken, but the individual names sit on the orders rather than on the item, so they are
          not published while a season is running. Saying so beats an empty row of chips. */}
      {!entry.open && entry.namesWithheld === true && (
        <div className="sp-open-state is-shared">
          <span className="sp-open-dot" />
          <span>
            <b>Shared by the community</b> &mdash; taken up by several members together.
          </span>
        </div>
      )}
      {!entry.open && entry.namesWithheld !== true && (
        <div className="sp-chips">
          {entry.sponsorNames.map((name, index) => (
            <span className="sp-chip" key={`${entry.anchorId}-${index}`}>
              {name}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}

export function SponsorSkeleton({ rows }) {
  const items = [];
  for (let i = 0; i < rows; i += 1) {
    items.push(<div className="sp-skel sp-skel-row" key={i} />);
  }
  return (
    <div className="sp-grid" aria-hidden="true">
      {items}
    </div>
  );
}

export function SponsorError({ onRetry }) {
  return (
    <div className="sp-error">
      <div className="sp-error-ico">&#9888;</div>
      <h3>We couldn't load the sponsor list</h3>
      <p>The sponsorship list didn't come through. Check your connection and try again.</p>
      <button className="hm-btn hm-btn-outline" type="button" onClick={onRetry}>
        Try again
      </button>
    </div>
  );
}
